module.exports = __webpack_public_path__ + "img/Gruselig.879a26d3.jpg";